import { render, staticRenderFns } from "./IndigoDollars.vue?vue&type=template&id=149d8f08&scoped=true&"
import script from "./IndigoDollars.vue?vue&type=script&lang=js&"
export * from "./IndigoDollars.vue?vue&type=script&lang=js&"
import style0 from "./IndigoDollars.vue?vue&type=style&index=0&id=149d8f08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149d8f08",
  null
  
)

export default component.exports